
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[user_id]/terms",
      function () {
        return require("private-next-pages/users/[user_id]/terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/[user_id]/terms"])
      });
    }
  